<!--------------------Password First Change-------------------->
<qr-overlay
  [(isOverlayVisible)]="isChangePasswordVisible"
  [config]="overlayChangePassword"
>
  <div>
    <qr-overlay-topbar (close)="closeChangePasswordOverlay()"
      >Cambiar contraseña</qr-overlay-topbar
    >
    <div>
      <ng-container *ngIf="showChangePasswordComponent">
        <app-dialog-change-password
          [value]="this.loggedUser"
          (change)="onChangePassword($event)"
        >
        </app-dialog-change-password>
      </ng-container>
    </div>
    <div class="botbar-actions">
      <qr-button
        [config]="btnCancel"
        (click)="closeChangePasswordOverlay()"
        class="button-cancel"
      ></qr-button>
      <qr-button
        [config]="btnSaveChangePassword"
        (click)="savePasswordChange()"
        [isDisabled]="isButtonSaveDisabled"
        class="button-action"
      ></qr-button>
    </div>
  </div>
</qr-overlay>

<!--------------------Popup-------------------->
<app-popup
  *ngIf="showPopup"
  [ngStyle]="{ display: enablePasswordUpdatePopup ? 'none' : 'block' }"
  [popupData]="popupData"
  (changeHaveMessage)="changeMessageStatus($event)"
></app-popup>

<!-- MENÚ LATERAL NUEVO - AR - DO - EC - PY -->
<div
  *ngIf="USES_NEW_MENU"
  class="sidebar"
  [ngStyle]="{
    'pointer-events': showPopup || enablePasswordUpdatePopup ? 'none' : 'auto'
  }"
  (mouseenter)="onSidebarEnter()"
  (mouseleave)="onSidebarLeave()"
>
  <div class="sidebar__logo-container">
    <a class="sidebar__logo" [href]="URL_HOME" matRipple>
      <div>
        <img src="/assets/img/new-logo/qr-blue.svg" alt="" />
      </div>
    </a>
    <div class="sidebar__brand-name">QR Solutions</div>
  </div>

  <!-- Modulos/secciones -->
  <ul class="sidebar__nav-list">
    <li
      *ngFor="let module of webModules; let i = index"
      matRipple
      (click)="toggleExpand(i)"
    >
      <a
        [class.active]="isModuleActive(module.url)"
        [attr.href]="getMainModuleHref(module)"
        [attr.target]="module.id === -1 ? '_blank' : null"
        (click)="onMainModuleLinkClick(module, $event)"
      >
        <div class="sidebar__icon-box">
          <div
            class="sidebar__icon-inner"
            [class.sidebar__icon-inner--notification]="module.id === 103"
          >
            <qr-icon
              [name]="module.icon"
              [color]="
                isModuleActive(module.url) ? COLOR_GREY_200 : COLOR_GREY_500
              "
            ></qr-icon>
          </div>
        </div>

        <div class="sidebar__label-nav">
          <span class="sidebar__label-nav-content">
            {{ module.label }}
            <!-- BADGE NUEVO -->
            <div
              class="badge-container-new"
              *ngIf="
                module.label == 'Inteligencia Artificial' || module.id == 103
              "
            >
              <p class="caption-01-bold">Nuevo</p>
            </div>
          </span>
          <qr-icon
            *ngIf="module.subItems?.length"
            class="sidebar__button-expand"
            [name]="ICON_EXPAND_MORE"
            [class.rotated]="itemExpand === i"
            [color]="COLOR_GREY_400"
          ></qr-icon>
        </div>
      </a>
      <!-- SUBITEMS -->
      <div
        class="sidebar__subitems-wrapper"
        [style.height.px]="getSubMenuHeight(i)"
      >
        <a
          *ngFor="let sub of module.subItems"
          [href]="hasPermission(sub) ? sub.url : null"
          [attr.target]="hasPermission(sub) ? '_self' : null"
          [class.active]="isModuleActive(sub.url)"
          (click)="onSubItemClick(sub, $event, module)"
        >
          <div class="sidebar__icon-box-empty"></div>
          <div class="sidebar__label-extra">
            <div class="sidebar__icon-box-subitem">
              <qr-icon
                [name]="sub.icon"
                [color]="
                  isModuleActive(sub.url) ? COLOR_GREY_100 : COLOR_GREY_400
                "
              ></qr-icon>
            </div>
            <p>{{ sub.label }}</p>
          </div>
        </a>
      </div>
    </li>
  </ul>

  <!---->
  <div class="line --top"></div>
  <div class="line --bottom"></div>
</div>

<!-- MENÚ LATERAL ANTIGUO - GL -->
<div
  *ngIf="!USES_NEW_MENU"
  id="sidebar"
  [ngStyle]="{
    'pointer-events': showPopup || enablePasswordUpdatePopup ? 'none' : 'auto'
  }"
>
  <div class="logo-container">
    <a class="logo" [href]="URL_HOME" matRipple>
      <div>
        <img src="/assets/img/new-logo/qr-blue.svg" alt="" />
      </div>
    </a>
    <div class="brand-name subheading-01-semi-bold">QR Solutions</div>
  </div>
  <!-- Modulos/secciones -->
  <ul class="nav-list">
    <li *ngFor="let module of webModulesRow" matRipple>
      <a
        (click)="onModuleClickEcPyGl(module, $event)"
        [class.active]="isModuleActive(module.url)"
        [attr.target]="module.id === -1 ? '_blank' : null"
      >
        <div class="icon-box">
          <qr-icon [name]="module.icon"></qr-icon>
        </div>
        <div class="label-nav subheading-01-semi-bold">
          {{ module.label }}
          <!-- BADGE BETA -->
          <div
            class="badge-container"
            *ngIf="module.label == 'Rendiciones' || module.id == 17"
          >
            <p class="caption-01-bold">BETA</p>
          </div>
        </div>
      </a>
    </li>
  </ul>
  <!---->
  <div class="line --top"></div>
  <div class="line --bottom"></div>
</div>

<!-- Button: Support contact (Central Chat) -->
<a
  class="support-button"
  [href]="URL_SUPPORT_CHAT"
  target="_blank"
  rel="noopener noreferrer"
  matTooltip="Soporte"
  matTooltipPosition="right"
  [ngStyle]="{
    'pointer-events': showPopup || enablePasswordUpdatePopup ? 'none' : 'auto'
  }"
  matRipple
>
  <qr-icon [name]="ICON_SUPPORT_AGENT" [color]="COLOR_PRIMARY_300"></qr-icon>
</a>

<!-- Botón: Menú de cuenta -->
<ng-container>
  <div
    [ngStyle]="{
      'pointer-events': showPopup || enablePasswordUpdatePopup ? 'none' : 'auto'
    }"
    class="account-button"
    (click)="visibleMenuUser = !visibleMenuUser"
    matRipple
  >
    <qr-icon
      [name]="ICON_ACCOUNT_CIRCLE"
      [color]="COLOR_GREY_500"
    ></qr-icon></div
></ng-container>

<div class="user-menu" *ngIf="visibleMenuUser">
  <div class="user-menu__name-user">
    <div class="user-menu__avatar">
      <img src="assets/img/default.png" alt="" />
    </div>
    <div class="user-menu__user-data">
      <p class="user-menu__full-name">{{ this.userDisplayName }}</p>
      <ng-container
        *ngIf="
          multiOfficeDropdown.options.length === 0;
          else multiOfficeDropdownContent
        "
      >
        <p class="user-menu__office">RE/MAX {{ this.officeName }}</p>
      </ng-container>
      <ng-template #multiOfficeDropdownContent>
        <qr-dropdown
          [config]="multiOfficeDropdown"
          [selected]="this.multiOfficeDropdownSelected"
          (change)="multiOfficeDropdownChange($event)"
        ></qr-dropdown>
      </ng-template>
    </div>
  </div>

  <div class="user-menu__currency" *ngIf="NODE != NODE_EC">
    <span>Moneda</span>
    <div class="user-menu__currency-switch">
      <qr-toggle
        [config]="toggleCurrency"
        (change)="toggleCurrencyChange($event)"
      ></qr-toggle>
    </div>
  </div>

  <ul class="user-menu__buttons-list">
    <a [href]="URL_CONFIGURATION" *ngIf="isConfigVisible()">
      <li matRipple>
        <div class="user-menu__icon">
          <qr-icon [name]="ICON_SETTINGS" [color]="COLOR_GREY_400"></qr-icon>
        </div>
        <span>Configuración</span>
      </li>
    </a>

    <li (click)="changePassword()">
      <div class="user-menu__icon">
        <qr-icon [name]="ICON_PASSWORD" [color]="COLOR_GREY_400"></qr-icon>
      </div>
      <span>Cambiar contraseña</span>
    </li>

    <a [href]="URL_SUPPORT">
      <li matRipple>
        <div class="user-menu__icon">
          <qr-icon [name]="ICON_SUPPORT" [color]="COLOR_GREY_400"></qr-icon>
        </div>
        <span>Ayuda y soporte</span>
      </li>
    </a>
    <li (click)="logout()" matRipple>
      <div class="user-menu__icon">
        <qr-icon [name]="ICON_LOGOUT" [color]="COLOR_GREY_400"></qr-icon>
      </div>
      <span>Cerrar sesión</span>
    </li>
  </ul>
</div>

<div
  id="main-container"
  *ngIf="userLoaded && currencyLoaded"
  (click)="closeMenuConfig()"
>
  <router-outlet></router-outlet>
</div>

<ng-template #skeletonLoader>
  <qr-skeleton-loader id="sk-sidebar"></qr-skeleton-loader>
</ng-template>

<app-loader-full-screen
  *ngIf="!userLoaded || !currencyLoaded"
></app-loader-full-screen>
